/**
 * Joins the truthy class names with a space, so a class can be toggled inline.
 *
 * @example
 * joinClassNames('row', isSelected && 'selected', className); // 'row selected' when selected and no className
 */
export const joinClassNames = (...classNames) => classNames.filter(Boolean).join(' ');
